import { render } from "./booking-add.vue?vue&type=template&id=4f6f8381"
import script from "./booking-add.vue?vue&type=script&lang=js"
export * from "./booking-add.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__